import { render, staticRenderFns } from "./StepsThird.vue?vue&type=template&id=4927d4d8&scoped=true"
import script from "./StepsThird.vue?vue&type=script&lang=js"
export * from "./StepsThird.vue?vue&type=script&lang=js"
import style0 from "./StepsThird.vue?vue&type=style&index=0&id=4927d4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927d4d8",
  null
  
)

export default component.exports